// extracted by mini-css-extract-plugin
export var cta = "index-module--cta--51b52";
export var image = "index-module--image--2536b";
export var postCount = "index-module--post-count--57f5e";
export var text = "index-module--text--4fded";
export var topicList = "index-module--topic-list--fb6b5";